import { LANGUAGES } from '@/constants/languages'

export default {
  name: 'LanguageSelect',
  data() {
    return {
      languages: LANGUAGES.map((lang) => ({ code: lang.key, name: lang.name })),
      isOpen: false,
    }
  },
  computed: {
    sortedLanguages() {
      return this.languages.sort((a, b) => {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
    },
    currentLanguage() {
      return this.languages.find((language) => language.code === localStorage.getItem('app_locale'))
    },
  },
  methods: {
    openLanguageSelector() {
      this.isOpen = !this.isOpen
    },

    selectLanguage(language) {
      localStorage.setItem('app_locale', language.code)
      this.isOpen = false
      window.location.reload()
    },
  },
}
